import React from 'react';

import { Typography, Divider } from '@mui/material';

import { useIntl } from '@klokhuis/core/Intl';
import { useListingSelectors } from '@klokhuis/modules/Properties/context/hooks/useListingSelectors';
import { CommonStyles } from '@klokhuis/styles/CommonStyles';

import { CarouselGenerator } from '../../CarouselGenerator/CarouselGenerator';

const FeaturedListingsInternal = () => {
  const { T } = useIntl();
  const topAdListings = useListingSelectors().getFeaturedListings();
  return (
    <section className={CommonStyles.margin_bottom_4}>
      {topAdListings && topAdListings.length > 0 && (
        <React.Fragment>
          <Typography variant="h5" className={CommonStyles.padding_block_1}>
            {T('LBL_FEATURED_TOP_ADS')}
          </Typography>
          <CarouselGenerator listings={topAdListings} />
          <Divider className={CommonStyles.margin_bottom_3} />
        </React.Fragment>
      )}
    </section>
  );
};
export const FeaturedListings = React.memo(FeaturedListingsInternal);
